var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('app-header'),_c('div',{staticClass:"container"},_vm._l((_vm.reviewables),function(reviewable){return _c('div',{key:reviewable.id,staticClass:"column"},[_c('rev-card',{attrs:{"reviewable":reviewable}})],1)}),0)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }